import { CreateService } from '@/services/service';
import APIBuilder from '@quangphuc/frontend-api-builder';
import { NotifyStaffEntity } from '@/entities/notify-staff.entity';

export default class NotifyStaffService extends CreateService<NotifyStaffEntity>('notify-staff') {
  async readNotify(staffId: number, notifyId: number): Promise<void> {
    await APIBuilder.axios.patch('/notify-staff/read-notify-by-id', { staffId, notifyId });
  }
}
